import {asMoneyString} from '../asMoneyString'
import {MouseBasedMenuManager} from '../MouseBasedMenuManager'
import {replaceInString} from '../replaceInString'
import 'bootstrap-input-spinner'

const $window = $(window)

/**
 * When you click the main menu toggle I'll make sure you can't scroll the page
 */
function initMenuToggle() {
	const bsl = require('body-scroll-lock')
	const $menu = $('.main-menu')
	const container = $menu.find('.inner-container').get(0)
	$('#toggle--main-menu').once('initMenuToggle').on('change', function () {
		if (this.checked) {
			bsl.disableBodyScroll(container)
		} else {
			bsl.enableBodyScroll(container)
		}
	})
}

/**
 * 1) When you mouseover a shop menu toggle I'll temporarily open the shop menu
 * 2) If you click on the shop menu toggle I'll just assume you want the menu
 *    open
 * 3) If you move your mouse down to the shop menu after a mouseover I'll
 *    assume that you want the menu permanently open
 * 4) If you click on anything that isn't the shop menu I'll close the menu for
 *    you
 */
function initShopToggle() {
	$('.desktop-menu label[for=toggle--shop]').once('initShopToggle').each(function () {
		const $label = $(this)
		const $rootContainer = $('#shopify-section-site-header')
		const $toggle = $('#toggle--shop')
		const $menu = $('.shop-menu.menu--toplevel')

		const mbmm = new MouseBasedMenuManager({
			$rootContainer,
			$menu,
			$label,
			$toggle,
			onLabelClickVisit: '/collections/all'
		})
		mbmm.start()

		$window.on('scroll', function (e) {
			$toggle.prop('checked', false)
		})

		$window.on('pointerdown', function (e) {
			const $target = $(e.target)
			const isInMenu = $target.parents().is('.shop-menu') || $target.is('.shop-menu')
			const isInLabel = $target.parents().is('label[for=toggle--shop]') || $target.is('label[for=toggle--shop]')
			if (!isInMenu && !isInLabel) {
				$toggle.prop('checked', false)
			}
		})
	})
}

function initHeaderSearch() {
	const $toggle = $('#header-search__toggle')
	$('.header-search').once('initHeaderSearch').each(function () {
		const $search = $(this)
		const $input = $search.find('.search__input')

		$toggle.on('change', function (e) {
			if (this.checked) {
				$input.focus()
				$input.select()
			}
		})
	})
}

function initCart() {
	$('.cart-link').once('initCart').each(function () {
		const $cart = $(this)
		const $count = $cart.find('.cart-link__count')
		$window.on('cart:onUpdateStart', function (e, cart) {
			$count.text(cart.getQuantity())
		})
		$window.on('cart:onUpdateEnd', function (e, cart) {
			$count.text(cart.getQuantity())
		})

		const $rootContainer = $('#shopify-section-site-header')
		const $toggle = $('#toggle--cart')
		const $menu = $('#quick-cart')

		const mbmm = new MouseBasedMenuManager({
			$rootContainer,
			$menu,
			$toggle,
			$label: $cart,
			onLabelClickVisit: '/cart'
		})
		mbmm.start()

		$window.on('pointerdown', function (e) {
			const $target = $(e.target)
			const isInMenu = $target.parents().is('#quick-cart') || $target.is('#quick-cart')
			if (!isInMenu) {
				$toggle.prop('checked', false)
			}
		})
	})
}

function initQuickCart() {
	$('#quick-cart').once('initQuickCart').each(function () {
		const $cart = $(this)
		const $itemTemplate = $cart.find('.quick-cart__template')
		const $isEmpty = $cart.find('.quick-cart__empty')
		const $items = $cart.find('.quick-cart__items')

		const dDescription = $cart.data('productDescription')
		const dOption1 = $cart.data('option1String')
		const dOption2 = $cart.data('option2String')

		cart.items.forEach(doAddItem)
		doMacroUpdate()

		$window.on('cart:onUpdateStart', doMacroUpdate)
		$window.on('cart:onItemAdded', function (e, item) {
			doAddItem(item)
			doMacroUpdate()
		})

		function doMacroUpdate() {
			if (cart.isEmpty()) {
				$isEmpty.show()
				$items.hide()
			} else {
				$isEmpty.hide()
				$items.show()
			}
		}

		/**
		 * Add an item to the quick-cart
		 * @param {CartItem} item
		 */
		function doAddItem(item) {
			const variant = item.getVariant()
			const description = replaceInString(dDescription, {
				title: item.getProductTitle(),
				price: asMoneyString(variant.price)
			})
			const option1 = replaceInString(dOption1, {option: item.getOption(1)})
			const option2 = replaceInString(dOption2, {option: item.getOption(2)})

			const $item = $itemTemplate.clone().removeClass('quick-cart__template')
			const $quantity = $item.find('.cart-item__quantity')

			$item.find('.cart-item__image').attr('src', item.getImage())
			$item.find('.cart-item__description').html(description)
			$item.find('.cart-item__option1').html(option1)
			$item.find('.cart-item__option2').html(option2)
			$quantity.change(function (e) {
				const quantity = parseInt($(this).val())
				if (quantity < 1) {
					return
				}
				item.setQuantity(quantity)
			}).inputSpinner({
				incrementButton: '<span class="icon-plus"></span>',
				decrementButton: '<span class="icon-minus"></span>',
				groupClass: 'item-quantity',
				buttonsClass: 'item-quantity__button',
				buttonsWidth: '28px'
			})
			$item.find('.cart-item__remove').on('click', function () {
				item.removeSelf()
				$item.remove()
				$window.off('cart:onUpdateEnd', doUpdateItemQuantity)
			})

			$window.on('cart:onUpdateEnd', doUpdateItemQuantity)
			doUpdateItemQuantity()

			$items.append($item)

			function doUpdateItemQuantity() {
				$quantity.val(item.getQuantity())
			}
		}
	})
}

function initToastManager() {
	$('.toasts').once('initToastManager').each(function () {
		const $toasts = $(this)
		const duration = $toasts.data('duration') || 1500
		const $template = $toasts.find('.toast--template')
		$window.on('quickAdd:itemAdded', function (e, {message}) {
			const $toast = $template.clone()
			$toast.removeClass('toast--template')
			$toasts.append($toast)
			$toast.find('.toast-body').text(message)
			$toast.toast({delay: duration}).toast('show')
		})
	})
}

function initScrollSpy() {
	function observePosition(element, classname) {
		if (
			'IntersectionObserver' in window &&
			'IntersectionObserverEntry' in window &&
			'intersectionRatio' in window.IntersectionObserverEntry.prototype
		) {
			let observer = new IntersectionObserver(entries => {
				if (entries[0].boundingClientRect.y < 0) {
					document.body.classList.add(classname)
				} else {
					document.body.classList.remove(classname)
				}
			})
			observer.observe(document.querySelector(element))
		}
	}

	observePosition('#top-of-site-pixel-anchor', 'header-not-at-top')
	observePosition('#near-top-of-site-pixel-anchor', 'header-not-near-top')
}

export function initHeader() {
	initMenuToggle()
	initShopToggle()
	initHeaderSearch()
	initCart()
	initQuickCart()
	initToastManager()
	initScrollSpy()
}